import { Box } from "@mui/material";
import React from "react";
import NewCustomerForm from "./NewCustomerForm";
import { useSelector } from "react-redux";
import Table from "./Table";
import DataExport from "./DataExport";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function NewCustomer() {
  const state = useSelector((store) => store.analyze);
  const { newCustomerDataPrepared, clearAnalyzeNewCustomer } = state;
  return (
    <Box>
      <NewCustomerForm />
      <CollapseSection title="Analyze New Customer">
        {newCustomerDataPrepared && clearAnalyzeNewCustomer ? (
          <DataExport />
        ) : null}

        {newCustomerDataPrepared && clearAnalyzeNewCustomer ? <Table /> : null}
      </CollapseSection>
    </Box>
  );
}
